import React, { useContext, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import { authService } from '../services/api';

// Renders only for logged-in users whose email isn't verified yet.
// Soft-mode: doesn't block any flow, just nags and offers a resend.
export const VerificationBanner = () => {
  const { user } = useContext(AuthContext);
  const [state, setState] = useState('idle');
  const [error, setError] = useState('');

  if (!user) return null;
  if (user.emailVerified) return null;

  const onResend = async () => {
    setState('sending');
    setError('');
    try {
      await authService.resendVerification();
      setState('sent');
    } catch (e) {
      setError(e.response?.data?.error || 'Could not resend right now.');
      setState('idle');
    }
  };

  return (
    <div className="bg-amber-500/10 border-b border-amber-500/30 text-amber-200 text-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
        <span className="flex-1">
          <span className="font-semibold">Verify your email</span> — check{' '}
          <span className="font-mono">{user.email}</span> for a link from OwnDecks. Some features will require it.
        </span>
        {state === 'sent' ? (
          <span className="text-amber-300 font-medium">Sent — check your inbox.</span>
        ) : (
          <button
            onClick={onResend}
            disabled={state === 'sending'}
            className="self-start sm:self-center px-3 py-1.5 rounded border border-amber-400/50 hover:bg-amber-500/10 font-semibold text-xs disabled:opacity-60 transition"
          >
            {state === 'sending' ? 'Sending…' : 'Resend email'}
          </button>
        )}
        {error && <span className="text-red-400 text-xs">{error}</span>}
      </div>
    </div>
  );
};
